import React from 'react';
import { CalendarIcon } from 'components/common/icons';
import { StatusTypes } from 'models/PurchaseRequest';
import { Col, CountrySelect, DatePicker, Form, FormInstance, Row, Select } from 'components';
import { AdminSelect, BrandSelect, ClientSelect, FilterDrawer } from 'components/common';
import { useFilters } from './useFilters';

const { RangePicker } = DatePicker;

interface IFilters {
  form: FormInstance;
  drawerOpen: boolean;
  closeDrawer: () => void;
  applyFilters: (value: Record<string, any>) => void;
  resetFilters: () => void;
}

export const Filters = React.memo((props: IFilters) => {
  const { form, drawerOpen, closeDrawer, applyFilters, resetFilters } = props;
  const { clearFilters } = useFilters({ form, resetFilters });

  return (
    <FilterDrawer
      title="Filter"
      placement="left"
      width={471}
      styles={{
        body: {
          marginBottom: 80,
        },
      }} // Add space for drawer actions
      onClose={closeDrawer}
      open={drawerOpen}
      onApply={() => form.submit()}
      onClear={clearFilters}
      onExpand={closeDrawer}
    >
      <Form layout="vertical" form={form} onFinish={applyFilters}>
        <Row gutter={[0, 16]}>
          <Col span={24}>
            <Form.Item name="brandId" label={'Brand'}>
              <BrandSelect />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="clientId" label={'Client Name'}>
              <ClientSelect />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="countryId" label={'Client Country'}>
              <CountrySelect />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="purchaseManagerId" label={'Purchase Manager'}>
              <AdminSelect />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="createDate" label={'Created Date'}>
              <RangePicker suffixIcon={<CalendarIcon />} className={'w-100'} popupClassName={'fmg-range-picker'} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="lastUpdatedDate" label={'Last Updated Date'}>
              <RangePicker suffixIcon={<CalendarIcon />} className={'w-100'} popupClassName={'fmg-range-picker'} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="status" label={'Status'}>
              <Select options={StatusTypes} mode={'multiple'} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </FilterDrawer>
  );
});
